/*
 * Project: xpenser-client
 * FilePath: /src/app/pages/Dashboard/index.tsx
 * File: index.tsx
 * Created Date: Friday, September 18th 2020, 6:47:35 pm
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Sat Sep 19 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React from 'react'
import { Link } from 'react-router-dom'

import Template, { Layouts } from '@pages/template'

import Header from '@components/header'
import Navigation from '@components/navigation'

export default function Dashboard () {
  const type: Layouts = 'primary'

  return (
    <Template
      type={type}
      header={Header}
      navigation={Navigation}
      content={() => {
        return (<p>Dashboard: <Link to="/logout">Logout</Link></p>)
      }}
    />
  )
}
